import { render } from "./About.vue?vue&type=template&id=61c7b8ba&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=61c7b8ba&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/muziekdichtbij/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c7b8ba"]])

export default __exports__